import { GameTimings, getGameTimings } from "@mono/constants"

import { useAppSelector } from "@/store/hooks"

// The clocks the game on screen is actually running on. A quick game's are
// shorter, and every countdown ring is drawn as currentTime/totalTime — so a
// ring handed the normal-pace total while the game is quick starts part-empty
// and hits zero while the server still has seconds left on the clock.
//
// Returns one of two shared objects rather than a fresh one, so it is safe in a
// dependency array.
export const useGameTimings = (): GameTimings => {
  const isQuickGame = useAppSelector(
    (state) => !!state.global.myGame?.settings?.isQuickGame
  )
  return getGameTimings({ settings: { isQuickGame } })
}
